import { PageHeader } from 'components/page';
import { useReduxState } from 'hooks';
import { getCustomizedNavTitle } from 'lib/helpers';
import { CoursesCreate, CoursesSearch } from '.';

interface Props {
  querySearchValue: string | undefined;
}

const CoursesHeader = ({ querySearchValue }: Props) => {
  const { language, messages, serverConfig, user } = useReduxState();

  return (
    <div className="courses-header">
      <PageHeader
        icon="book"
        title={getCustomizedNavTitle({
          defaultTitle: messages.commonCourses,
          navLinksCustomTexts: serverConfig.navLinksCustomTexts,
          language,
          section: 'courses'
        })}
      >
        <div className="row row-reverse">
          {user &&
          ((user.roles.includes('admin') &&
            user.permissions.includes('create-courses')) ||
            user.roles.includes('superadmin')) ? (
            <div className="col-min col-right">
              <CoursesCreate />
            </div>
          ) : null}

          <div className="col">
            <div className="search">
              <CoursesSearch initialValue={querySearchValue} />
            </div>
          </div>
        </div>
      </PageHeader>

      <style jsx>{`
        .search {
          max-width: 100%;
          width: 320px;
        }
      `}</style>
    </div>
  );
};

export default CoursesHeader;
